export enum PaymentType
{
    BetalingService,
    Dibs
}
